import React from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";

function ProjectsChart({ chartData }) {
  const data = chartData.datasets[0].data;
  const colors = chartData.datasets[0].backgroundColor;
  const labels = chartData.labels;

  let cumulative = 0;

  const getCoordinatesForPercent = (percent) => {
    const x = Math.cos(2 * Math.PI * percent);
    const y = Math.sin(2 * Math.PI * percent);
    return [x, y];
  };

  return (
    <Card className="p-3 shadow-sm">
      {/* Header */}
      <div className="d-flex mb-0" style={{ height: "10px" }}>
        <h6 className="mb-0">Project By Task</h6>

        <Dropdown className="ms-auto">
          <Dropdown.Toggle size="sm" variant="light">
            Office Management App
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>App 1</Dropdown.Item>
            <Dropdown.Item>App 2</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <Row className="align-items-center">
        {/* Pie Chart */}
        <Col md={6} className="text-center">
          <svg
            viewBox="-1 -1 2 2"
            style={{ transform: "rotate(-90deg)", width: "200px" }}
          >
            {data.map((value, i) => {
              const [startX, startY] = getCoordinatesForPercent(cumulative);
              cumulative += value / 100;
              const [endX, endY] = getCoordinatesForPercent(cumulative);

              const largeArcFlag = value > 50 ? 1 : 0;

              const pathData = `
                M ${startX} ${startY}
                A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}
                L 0 0
              `;

              return <path key={i} d={pathData} fill={colors[i]} />;
            })}
          </svg>
        </Col>

        {/* Legend */}
        <Col md={6}>
          {labels.map((label, i) => (
            <div key={i} className="d-flex align-items-center mb-3">
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: colors[i],
                  marginRight: "10px",
                }}
              />
              <div>
                <div style={{ fontSize: "14px" }}>{label}</div>
                <small className="text-muted">{data[i]}%</small>
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </Card>
  );
}

export default ProjectsChart;